interface IPalette {
  gray: string[];
  primary_main: string[];
  primary_light: string[];
  secondary_main: string[];
  secondary_light: string[];
  secondary_dark: string[];
}

export const palette: IPalette = {
  gray: ['#DBDBDB', '#C4C5C6', '#A0A1A4', '#7C7D7E'],
  primary_main: ['#D0C0DC', '#B090C8', '#9060B4', '#7030A0'],
  primary_light: ['#E5DBEC', '#DAC6E9', '#CEB0E5', '#C39BE1'],
  secondary_main: ['#BCC8D2', '#889FB5', '#537797', '#1F4E79'],
  secondary_light: ['#DCE9F2', '#C7E2F4', '#B3DBF6', '#9ED4F8'],
  secondary_dark: ['#B4BCCC', '#7888A8', '#3C5484', '#002060'],
};
